import * as C from '../constants';

export default {
  [C.SCHEDULES_PENDING](state) {
    state.schedules = {
      ...state.schedules,
      loading: true,
      error: false,
    };
  },
  [C.SCHEDULES_SUCCESS](state, payload) {
    state.schedules = {
      ...state.schedules,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULES_FAILURE](state) {
    state.schedules = {
      ...state.schedules,
      loading: false,
      error: true,
      items: [],
    };
  },
  [C.SCHEDULES_SEARCH](state, payload) {
    state.schedules = {
      ...state.schedules,
      search: payload,
    };
  },
  [C.SCHEDULES_POST_PENDING](state) {
    state.postSchedule = {
      ...state.postSchedule,
      loading: true,
      error: false,
    };
  },
  [C.SCHEDULES_POST_SUCCESS](state, payload) {
    state.postSchedule = {
      ...state.postSchedule,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULES_POST_FAILURE](state, payload) {
    state.postSchedule = {
      ...state.postSchedule,
      loading: false,
      error: true,
      items: payload,
    };
  },
  [C.SCHEDULES_EDIT_UPDATE_PENDING](state) {
    state.editSchedules = {
      ...state.editSchedules,
      loading: false,
      error: false,
      items: [],
    };
  },
  [C.SCHEDULES_EDIT_UPDATE_SUCCESS](state, payload) {
    state.editSchedules = {
      ...state.editSchedules,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULES_EDIT_UPDATE_FAILURE](state) {
    state.editSchedules = {
      ...state.editSchedules,
      loading: false,
      error: false,
      items: [],
    };
  },
  [C.SCHEDULES_EDIT_SUCCESS](state, payload) {
    state.editSchedules = {
      ...state.editSchedules,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULE_EDIT](state, payload) {
    state.editSchedules = {
      ...state.editSchedules,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULE_DELETE_PENDING](state) {
    state.deletedSchedule = {
      ...state.deletedSchedule,
      loading: true,
      error: false,
    };
  },
  [C.SCHEDULE_DELETE_SUCCESS](state, payload) {
    state.deletedSchedule = {
      ...state.deletedSchedule,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULE_DELETE_FAILURE](state) {
    state.deletedSchedule = {
      ...state.deletedSchedule,
      loading: false,
      error: true,
      items: [],
    };
  },
  [C.SCHEDULE_PATCH_PENDING](state) {
    state.patchSchedule = {
      ...state.patchSchedule,
      loading: true,
      error: false,
    };
  },
  [C.SCHEDULE_PATCH_SUCCESS](state, payload) {
    state.patchSchedule = {
      ...state.patchSchedule,
      loading: false,
      error: false,
      items: payload,
    };
  },
  [C.SCHEDULE_PATCH_FAILURE](state, payload) {
    state.patchSchedule = {
      ...state.patchSchedule,
      loading: false,
      error: true,
      items: payload,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/schedules/mutations.js